<template>
    <v-layout row>
        <v-flex xs12>
            <v-card flat xs12>
                <v-toolbar flat>
                    <v-toolbar-title>{{manifest ? "Create Order From Manifest: "+manifest.global_id : "New Order"}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                    <OrdersSampleForm :samples="samples" @newsample="addSample"/>
                </v-card-text>
                <v-card flat outlined>
                    <v-toolbar flat>
                        <v-toolbar-title>Ordered Samples:</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <v-layout>
                            <v-flex xs12 md6 lg3>
                                <p class="subheading">Name</p>
                            </v-flex>
                            <v-flex xs12 md6 lg3>
                                <p class="subheading">Type</p>
                            </v-flex>
                            <v-flex xs12 md6 lg3>
                                <p class="subheading">QA</p>
                            </v-flex>
                            <v-flex xs12 md6 lg3>
                                <p class="subheading">Lot</p>
                            </v-flex>
                            <v-flex xs12 md6 lg3>
                                <p class="subheading">Weight</p>
                            </v-flex>
                            <v-flex xs12 md6 lg3>
                                <p class="subheading">Unit</p>
                            </v-flex>
                            <v-flex xs12 md6 lg3>
                                <p class="subheading">Tests</p>
                            </v-flex>
                            <v-flex xs12 md6 lg3>
                                <p class="subheading"></p>
                            </v-flex>
                        </v-layout>
                        <v-layout v-for="(sample, index) in order">
                            <v-flex xs12 md6 lg3>{{sample.name}}</v-flex>
                            <v-flex xs12 md6 lg3>{{sample.sample_type_name}}</v-flex>
                            <v-flex xs12 md6 lg3>{{sample.qa}}</v-flex>
                            <v-flex xs12 md6 lg3>{{sample.lot}}</v-flex>
                            <v-flex xs12 md6 lg3>{{sample.weight}}</v-flex>
                            <v-flex xs12 md6 lg3>{{sample.unitName}}</v-flex>
                            <v-flex xs12 md6 lg3>
                                <v-layout row>
                                    <template v-for="(test,testIndex) in sample.tests">
                                        <span :key="testIndex" v-if="!((testIndex*1+1) === sample.tests.length)">{{test .name}},</span>
                                        <span :key="testIndex" v-else>{{test .name}}</span>
                                    </template>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 md6 lg3>
                                <v-btn color="error" @click="removeSample(index)" small outlined icon text><v-icon>delete</v-icon></v-btn>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                    <v-divider v-if="order.length > 0"></v-divider>
                    <v-card-actions v-if="order.length > 0">
                        <v-spacer></v-spacer>
                        <v-btn color="success" :loading="controls.loading" @click="saveOrder()">Submit Order</v-btn>
                    </v-card-actions>
                </v-card>

            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import CustomerDropdown from "../../components/CustomerDropdown"
    import OrdersSampleForm from "../../components/OrdersSampleForm"
    import Log from "../../Lib/FirebaseModels/Log"
    import recorded from '../../Lib/Recorded';
    export default {
        name: "Orders",
        components: {
            OrdersSampleForm
        },
        computed: {
            sampleCount() {
                return this.order.count()
            }
        },
        data() {
            return {
                controls: {
                    loading: false
                },
                order: [],
                demographics: {
                    manifest_id: null,
                    customer_id: null,
                    customerName: null,
                },
                sample: [],
                tests: [],
                //if manifest is passed
                samples: null,
            }
        },
        props:{
          manifest:{
              default:null,
          }
        },
        watch:{
            manifest(v){
                if(v){
                    console.log('manifest added');
                    this.samples = v.inventory_transfer_items;
                }
            }
        },
        created(){
            this.order = [];
          if(!this.samples && this.manifest){
              this.samples = this.manifest.inventory_transfer_items;
          }
        },
        methods: {
            addSample(newSampleObject) {
                let sample = {
                    manifest_id: newSampleObject.manifest_id,
                    id: newSampleObject.id,
                    name: newSampleObject.name,
                    customer_id: newSampleObject.customer_id,
                    sample_type_uuid: newSampleObject.sample_type_uuid,
                    sample_type_name: newSampleObject.sample_type_name,
                    legal_type: newSampleObject.legal_type,
                    qa: newSampleObject.qa,
                    lot: newSampleObject.lot,
                    harvest_date: newSampleObject.harvest_date,
                    weight: newSampleObject.weight,
                    unit_uuid: newSampleObject.unit_uuid,
                    unitName: newSampleObject.unitName,
                    tests: []
                };
                for(let i in newSampleObject.tests){
                    sample.tests.push(newSampleObject.tests[i])
                }
                this.order.push(sample)
            },
            removeSample(index){
                this.order.splice(index, 1);
            },
            async saveOrder(){
                this.controls.loading = true
                for(let i in this.order){
                    // Save sample
                    let sampleObject = this.order[i];
                    let sampleId = await recorded.get('/factories/samples/highest');
                    let sample = await recorded.post('/samples', {
                        id: sampleId.data*1+1,
                        name: sampleObject.name,
                        customer_id: sampleObject.customer_id,
                        manifest_id: sampleObject.manifest_id,
                        sample_type_uuid: sampleObject.sample_type_uuid,
                        legal_type: sampleObject.sample_type_uuid,
                        qa: sampleObject.qa,
                        lot: sampleObject.lot,
                        harvest_date: sampleObject.harvest_date,
                        weight: 0,
                        unit_uuid: sampleObject.unit_uuid,
                        created_by: this.$store.getters.id,
                        updated_by: this.$store.getters.id

                    });
                    // snag sample uuid
                    let sampleUuid = sample.data.uuid;
                    for(let testIndex in sampleObject.tests){
                        // save sample tests
                        await recorded.post('/sampleTests', {
                            sample_uuid: sampleUuid,
                            sample_test_type_uuid: sampleObject.tests[testIndex].uuid,
                            mass: 0,
                            unit_uuid: sample.data.unit_uuid,
                            passed: 0,
                            complete: 0,
                            active: 1,
                            created_by: this.$store.getters.id,
                            updated_by: this.$store.getters.id
                        })
                    }
                }
                // Logging
                this.logOrder();

                this.$store.dispatch('showSuccess', 'Order saved.')
                this.controls.loading = false
                this.resetOrder()
            },
            resetOrder() {
                this.order = []
            },
            logOrder() {
                let userLog = new Log('/users/' + this.$store.getters.id + "/log")
                userLog.fillable.event = "Create";
                userLog.fillable.description = this.$store.getters.name + " created a new order with " + this.order.length + " samples.";
                userLog.fillable.data = this.order;
                userLog.save().then(response => {
                    if(response){
                        let mainLog = new Log('/logs/' + userLog.generatedKey, true)
                        mainLog.fillable = userLog.fillable;
                        mainLog.save().catch(error => { this.$store.dispatch("showError", error) });
                    }else{
                        this.$store.dispatch('showError', "Failed to log data change please contact the dev team.")
                    }
                })
            }

        }
    }
</script>

<style scoped>

</style>
